import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import EquipmentService from "@services/EquipmentService";

const ShowEquipment = ({ equipment }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [equipmentData, setEquipmentData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      EquipmentService.find(equipment.id).then((response) => {
        setEquipmentData(response.data.data);
      });
  }, [equipment.id, showModal]);

  return (
    <PermissionHandler permission={"view_equipments"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={equipmentData.name} />
          <RowDetails label={t("nameEng")} value={equipmentData.name_eng} />
          <RowDetails
            label={t("description")}
            value={equipmentData.description}
          />
          <RowDetails
            label={t("equipmentCategoryName")}
            value={equipmentData?.category?.name}
          />
          <RowDetails
            label={t("equipmentCategoryNameEng")}
            value={equipmentData?.category?.name_eng}
          />
          <RowDetails
            label={t("equipmentCategoryDescription")}
            value={equipmentData?.category?.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowEquipment;
